import { render, staticRenderFns } from "./AllocationPage.vue?vue&type=template&id=dcbf74a2&"
import script from "./AllocationPage.vue?vue&type=script&lang=js&"
export * from "./AllocationPage.vue?vue&type=script&lang=js&"
import style1 from "./AllocationPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports